module.exports = __webpack_public_path__ + "static/media/icon-probate-negative.6cb43a22.svg";